import LikertScale from '../components/LikertScale'
import InfoButton from '../components/InfoButton'
import Link from '../components/Link'
import Typography from '@mui/material/Typography'
import Chip from '@mui/material/Chip'
import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box'
import { ReactComponent as IconFaceBenefit } from '../icons/FaceBenefit.svg'
import { ReactComponent as IconFaceLimitation } from '../icons/FaceLimitation.svg'
import { ReactComponent as IconFaceObstacle } from '../icons/FaceObstacle.svg'
import useContentful from '../contexts/useContentful'

const Consequences = ({
  label,
  icon,
  consequences,
  color,
}) => {

  if (!consequences?.length) return null

  return (
    <Stack
      gap={1.5}
    >
      <Stack
        display="grid"
        gap={1}
        gridAutoFlow="column"
        justifyContent="flex-start"
        alignItems="center"
        alignContent="center"
      >
        {icon}
        <Typography
          variant="body1Semibold"
        >
          {label}
        </Typography>
      </Stack>
      <Stack
        gap={1.5}
      >
        {consequences?.map(o => (
          <Stack
            key={o.fields?.label}
            display="grid"
            gap={1}
            gridAutoFlow="column"
            justifyContent="flex-start"
            alignItems="center"
            alignContent="center"
          >
            <Chip
              key={o.fields?.label}
              size="small"
              label={o.fields?.category}
              sx={theme => ({
                ...theme.typography.labelUpper,
                borderRadius: 10,
                minWidth: 50,
                color: `status.${color}.main`,
                bgcolor: `status.${color}.lightest`,
              })}
            />
            <Typography
              variant="labelUpper"
            >
              {o.fields?.label}
            </Typography>
            {!!o?.fields?.tooltip?.length && (
              <InfoButton
                tooltipText={o?.fields?.tooltip}
              />
            )}
          </Stack>
        ))}
      </Stack>
    </Stack>
  )
}

const Callout = ({
  label,
  imageUrl,
  title,
  description,
  impact,
  value,
  onChange,

  benefits,
  limitations,
  obstacles,

  visualizationText,
  visualizationTitle,
  visualizationImage,
  onOpenVisualization,
}) => {
  const {
    other,
  } = useContentful()
  const labels = other?.[0]?.fields?.consequenceLabels || []
  
  return (
    <Stack
      display="grid"
      gap={4}
    >
      <Typography
        variant="bigLabelUpper"
      >
        {label}
      </Typography>
      <Stack
        display="grid"
        gap={4}
        gridTemplateColumns={{
          md: 'auto 1fr',
        }}
      >
        <Box
          sx={{
            width: '100%',
            maxWidth: '400px',
            aspectRatio: '1',
            borderRadius: '8px',
            overflow: 'hidden',
            justifySelf: 'center',
          }}
        >
          <img src={imageUrl} alt="" />
        </Box>
        <Stack
          gap={3}
        >
          <Typography
            variant="h4Bold"
            color="text.neutralDark"
          >
            {title}
          </Typography>
          <Stack
            gap={1}
          >
            <Typography
              color="text.neutralDark"
            >
              {description}
            </Typography>
            {!!visualizationImage?.fields?.file?.url && (
              <Link
                onClick={() => onOpenVisualization({ image: visualizationImage, text: visualizationTitle })}
              >
                {visualizationText}
              </Link>
            )}
          </Stack>
          <Consequences
            icon={<IconFaceBenefit />}
            label={labels[0]}
            color="success"
            consequences={benefits}
          />
          <Consequences
            icon={<IconFaceLimitation />}
            label={labels[1]}
            color="warning"
            consequences={limitations}
          />
          <Consequences
            icon={<IconFaceObstacle />}
            label={labels[2]}
            color="error"
            consequences={obstacles}
          />
        </Stack>
      </Stack>
      <Box
        maxWidth="650px"
        width="100%"
        justifySelf="center"
      >
        <LikertScale
          value={value}
          onChange={onChange}
        />
      </Box>
    </Stack>
  )
}

export default Callout